/**
 * Persiste la session après checkout invité (auto-login B-7 UX).
 * @returns {boolean} true si token + user ont été enregistrés
 */
export function persistCheckoutAuthSession(auth) {
  if (!auth?.access_token && !auth?.accessToken) {
    return false;
  }
  if (!auth?.user) {
    return false;
  }

  if (typeof window === 'undefined') {
    return false;
  }

  const token = auth.access_token ?? auth.accessToken;
  window.localStorage.setItem('access_token', token);
  window.localStorage.setItem('user', JSON.stringify(auth.user));
  window.localStorage.setItem('remember_me', 'true');
  window.sessionStorage.removeItem('access_token');
  window.sessionStorage.removeItem('user');
  return true;
}
